import React, { Component, useEffect, useState } from "react";
import Form from "../../../comman/form";
import http from "../../../services/HttpService";
import config from "../../../config.json";
import { Link } from "react-router-dom";
import Joi from "joi-browser";
import Swal from "sweetalert2";
import EditPartner from "../../SystemAdministration/ManagePartner/EditPartner";
import { getPartnerListByType, getRecruiterPartners, loadPartnerListByrecType, loadPartnerListByType, loadRecruiterPartners, partnerListByRecType } from "../../../app/store/partner";
import { addNewRates, getRateUpdatedStatus, ratesReceived, updateRate } from "../../../app/store/rates";
import { useDispatch, useSelector } from "react-redux";
import { getApplicationData } from "../../../app/store/application";
import { getCandidateUpatedStatus, updateNewCandidate } from "../../../app/store/candidate";
import { getAlert } from "../../../services/appAlerts";
import { loadRecruiters } from "../../../app/store/recruiter";
import { getDataTypeApplicationReports, loadDataTypeApplicationReports } from "../../../app/store/reports";
import { getCurrentUser } from "../../../app/store/auth";

const Recruiter = (props) => {

  const { candidateObj, actType, handleNextTab, updateSelectedObject, rateHistory } = props;

  const [recruiters, setRecruiters] = useState([]);
  const [recruiterId, setRecruiterId] = useState(0);
  const [recruiterRate, setRecruiterRate] = useState(0);
  const [recuiterLessFee, setRecuiterLessFee] = useState(0);
  const [recruiterFinalRate, setRecruiterFinalRate] = useState(0);
  const [partnerType, setPartnerType] = useState("Recruiter");
  const [aworkfinityApp, setAworkfinityApp] = useState(null);
  const [ShowHideRec, setShowHideRec] = useState(false);
  const [showDetailRec, setShowDetailRec] = useState(false);
  const [fetchValue, setFetchValue] = useState(false);
  const [allReportData, setAllReportData] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [selectedJsonData, setSelectedJsonData] = useState("");
  const [partnerListByType, setPartnerListByType] = useState([]);
  const [compName, setCompName] = useState("");
  const [btnUnable, setBtnUnable] = useState(false);
  // const [dropdownKey, setDropdownKey] = useState("");

  const recruiterPartnersSelector = useSelector(getRecruiterPartners);
  const rateUpdatedStatusSelector = useSelector(getRateUpdatedStatus);
  const partnerListByTypeSelector = useSelector(partnerListByRecType);
  const dataTypeApplicationReportsSelector = useSelector(getDataTypeApplicationReports);

  const candidateUpatedStatusSelector = useSelector(getCandidateUpatedStatus)

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();
  useEffect(() => {
    dispatch(loadRecruiterPartners(partnerType))
  }, []);

  useEffect(() => {
    setPartnerListByType(partnerListByTypeSelector);
    setFetchValue(false)
  }, [partnerListByTypeSelector]);


  useEffect(() => {
    if (recruiterPartnersSelector.length > 0) {
      const recList = recruiterPartnersSelector.filter((x) => x.createdBy !== "");
      setRecruiters(recList);
      setFetchValue(false)
      dispatch(loadDataTypeApplicationReports());
    }
  }, [recruiterPartnersSelector]);

  useEffect(() => {
    if (dataTypeApplicationReportsSelector.length > 0) {
      const rptDt = dataTypeApplicationReportsSelector;
      setAllReportData(rptDt);
    }
  }, [dataTypeApplicationReportsSelector]);

  useEffect(() => {

    if (!candidateObj) {
      setRecruiterId(0);
      // setRecruiterRate(0)
    }

    if (candidateObj?.recruiter)
      setRecruiterId(candidateObj.recruiter.fuid);

    const data = { ...rateHistory[rateHistory.length - 1] };
    if (data["recruiterRate"]) {
      setRecruiterFinalRate(data["recruiterRate"])
      setRecuiterLessFee(data["recruiterTechFee"] || 0)
      setRecruiterRate(parseFloat(data["recruiterRate"]) + parseFloat(data["recruiterTechFee"] || 0))
    } else if (actType === "edit") {
      setRecruiterFinalRate("")
      setRecuiterLessFee("")
      setRecruiterRate("")
    }
    // else
    //   if (candidateObj?.rates) {
    //     setRecruiterRate(candidateObj.rates.recruiterRate ?? 0);
    //   }

    if (candidateObj?.performerData) {
      const obj = getApplicationData(candidateObj.performerData);
      if (obj?.aWorkfinityApp)
        setAworkfinityApp(obj.aWorkfinityApp);
    }
    setBtnUnable(false)

  }, [candidateObj, rateHistory]);

  useEffect(() => {
    if (allReportData.length > 0) {
      let rptData = [];
      rptData = allReportData.filter((x) => x.name === "RecruiterEnrollmentForm");
      setReportData(rptData);
    }

  }, [allReportData])

  const handleSubmit = (btnType) => {
    const NewAWorkfinityApp = { ...aworkfinityApp };
    const appName = Object.keys(NewAWorkfinityApp)[1];
    const aWorkfinityAppEntity = NewAWorkfinityApp[appName];

    if (recruiterId > 0) {
      const subs = recruiters.filter(x => x.fuid === recruiterId);
      if (subs.length > 0) {
        const subDetails = JSON.parse(subs[0].createdBy);
        const appEntity = subDetails[appName];
        aWorkfinityAppEntity["recruiterenrollmentform"] = appEntity["recruiterenrollmentform"];
        NewAWorkfinityApp[appName] = aWorkfinityAppEntity;
        setBtnUnable(true)
        const formData = new FormData();
        formData.append("appEntity", JSON.stringify(NewAWorkfinityApp));
        formData.append("subcontractor", "");
        formData.append("recruiter", recruiterId);
        formData.append("perfId", candidateObj.performerid);
        dispatch(updateNewCandidate(formData));
        // if (actType === "edit") {
        //   updateSelectedObject(candidateObj.performerid, aworkfinityApp);
        // } else {
        //   updateSelectedObject(candidateObj.performerid);
        // }
        //handleSaveRates();

        // if (actType === "edit"){
        //   getAlert("", "Updated Successfully", "success");
        // }
        // else{
        //   getAlert("", "Saved Successfully", "success");
        // } 
        //updateSelectedObject(candidateObj.performerid);
        //dispatch(ratesReceived([]));
        //handleNextTab(btnType);
        setCompName("recruiter")
      }
    }

  };

  const handleUpdaterates = () => {
    const data = { ...rateHistory[rateHistory.length - 1] };
    const rateObj = {
      performerId: candidateObj.performerid,
      id: data.id,
      addedBy: currentUser.id,
      notes: data["notes"],
      subcontractorRate: data["subcontractorRate"],
      recruiterRate: recruiterFinalRate || 0,
      SubcontractorTechFee: data["subcontractorTechFee"] || 0,
      CandidateTechFee: data["candidateTechFee"] || 0,
      RecruiterTechFee: recuiterLessFee || 0,
      AgencyTechFee: data["agencyTechFee"] || 0,
      candidateRate: data["candidateRate"] || 0,
      agencyRate: data["agencyRate"] || 0,
      candidateEffectiveDate: data["candidateEffectiveDate"] || new Date().toISOString(),
      agencyEffectiveDate: data["agencyEffectiveDate"] || new Date().toISOString(),
      subcontractorEffectiveDate: data["subcontractorEffectiveDate"] || new Date().toISOString(),
      recruiterEffectiveDate: data["recruiterEffectiveDate"] || new Date().toISOString(),
    };
    dispatch(addNewRates(rateObj))
  }

  useEffect(() => {

    if (candidateUpatedStatusSelector && compName === "recruiter") {
      setCompName("");
      if (actType === "edit") {
        getAlert("", "Updated Successfully", "success");
        handleUpdaterates();
      }
      else {
        getAlert("", "Saved Successfully", "success");
      }

      updateSelectedObject(candidateObj.performerid, aworkfinityApp);
      handleSaveRates();
      //handleNextTab(btnType);
    }
  }, [candidateUpatedStatusSelector])


  const getAttributeValue = (d, t, att) => {
    if (d?.appData && d.appData === "") return "";
    const itemValues = JSON.parse(d.appData);
    const appShortName = Object.keys(itemValues)[1];
    const items = itemValues[appShortName][t.name.toLowerCase()];
    return items && items["@" + att];
  };

  const getAttribute = (t) => {
    if (t?.data && t?.data !== "") {
      const items = JSON.parse(t.data);
      return items;
    }
    return [];
  };

  const handleAddEditRecruiter = (data) => {
    if (data === "exit") {
      setShowHideRec(!ShowHideRec);
      dispatch(loadRecruiterPartners(partnerType));
      setFetchValue(true)
    }
  };

  const handleSaveRates = () => {
    const frmData = new FormData();
    frmData.append("id", candidateObj.performerid);
    frmData.append("type", "recruiter");
    frmData.append("recRate", recruiterFinalRate || 0);
    frmData.append("recTechFee", recuiterLessFee || 0);
    dispatch(updateRate(frmData));
  };

  useEffect(() => {
    const rate = parseFloat(recruiterRate) || 0;
    const lessFee = parseFloat(recuiterLessFee) || 0;

    const finalRate = rate - lessFee;
    setRecruiterFinalRate(isNaN(finalRate) ? 0 : finalRate);
  }, [recruiterRate, recuiterLessFee]);

  const ChangeRatePerHour = (rateVal) => {
    const rate = parseFloat(rateVal) || 0;
    setRecruiterRate(rate);
  };

  const ChangeLessTechFee = (rateVal) => {
    const fee = parseFloat(rateVal) || 0;
    if (fee <= recruiterRate || isNaN(fee)) {
      setRecuiterLessFee(fee);
    }
  };

  const handleRecShow = () => {
    setShowHideRec(!ShowHideRec)
    setShowDetailRec(false)
  }

  const handleRecDetails = () => {
    setShowHideRec(false)
    setShowDetailRec(!showDetailRec)
    const id = recruiterId
    let jsonData = "";
    const partner = partnerListByType.filter((x) => x.fuid === parseInt(id));
    if (partner.length > 0) {
      jsonData = partner[0].contact1?.performerData
    }
    setSelectedJsonData(jsonData);
  }

  const handleChangeRecruiter = ({ currentTarget: input }) => {
    const id = input.value;
    setRecruiterId(parseInt(id))
    dispatch(loadPartnerListByrecType(partnerType, id))
    setShowHideRec(false)
    setShowDetailRec(false)
  }

  const btnDisabled = recruiterId > 0 && recruiterRate > 0;

  return (
    <div className="col-md-12">
      <div className="row">
        <button
          className="btn btn-sm btn-outline-default ml-3 mb-2"
          onClick={() => handleRecShow()}
        >
          Add New Recruiter
        </button>
        {recruiterId ?
          <button
            className="btn btn-sm btn-outline-default ml-3 mb-2"
            onClick={() => handleRecDetails()}
          >
            View Recruiter Details
          </button> : ""
        }
        {!ShowHideRec ?
          <>
            <div className="col-md-12 form-group">
              <p className="text-red">
                <i className="fa fa-hand-o-right mr-2" aria-hidden="true"></i>
                If existing recruiter, Select recruiter and enter the rate to be
                paid
              </p>
            </div>
            <div className="col-md-3 form-group">
              <label htmlFor="recruiter" className="form-control-label">
                Select Recruiter
              </label>
              <select
                name="recruiter"
                // key={dropdownKey}
                disabled={fetchValue}
                id="recruiter"
                className="form-control"
                onChange={handleChangeRecruiter}
                value={recruiterId}
              >
                {/* <option value="">Select</option> */}
                <option value="">Not Applicable</option>
                {recruiters.map((item) => (
                  <option value={item.fuid}>{item.label}</option>
                ))}
              </select>
            </div>

            <div className="col-md-3 form-group">
              <label htmlFor="subcontractor" className="form-control-label">
                Rate/Hour-Paid to Recruiter $
              </label>
              <input
                className="form-control"
                type="number"
                name="rate"
                id="rate"
                value={recruiterRate}
                disabled={!recruiterId}
                onChange={({ currentTarget }) => ChangeRatePerHour(currentTarget.value)}
              />
            </div>

            <div className="col-md-3 form-group">
              <label htmlFor="reclessTechFee" className="form-control-label">
                Less Tech Fee $
              </label>
              <input
                className="form-control"
                type="number"
                name="reclessTechFee"
                id="reclessTechFee"
                value={recuiterLessFee}
                disabled={!recruiterId}
                onChange={({ currentTarget }) => ChangeLessTechFee(currentTarget.value)}
              />
            </div>

            <div className="col-md-3 form-group">
              <label htmlFor="finalRate" className="form-control-label">
                Final Recruiter Rate $
              </label>
              <input
                className="form-control"
                type="number"
                name="finalRate"
                id="finalRate"
                disabled
                value={recruiterFinalRate}
              />
            </div>

            <div className="col-md-12 text-center form-group">
              <button
                className="btn btn-sm btn-outline-default"
                disabled={!btnDisabled || btnUnable}
                onClick={() => handleSubmit("save")}
              >
                <i className="fa fa-check" aria-hidden="true"></i> Save
              </button>
              {/* <button
                className="btn btn-sm btn-outline-default"
                disabled={!btnDisabled}
                onClick={() => handleSubmit("saveAndContinue")}
              >
                <i className="fa fa-check" aria-hidden="true"></i> Save and Continue
              </button> */}
            </div>
            {
              showDetailRec &&
              <>
                {selectedJsonData && reportData.map((t, key) => (
                  <table className="table border align-items-center table-flush">
                    <thead className="thead-light">
                      {getAttribute(t).length > 0 &&
                        getAttribute(t).map((m) => (
                          <tr>
                            <td style={{ width: "20%", backgroundColor: "#f6f6f6" }} className="p-2">{m.Label}</td>
                            <td className="p-2">
                              {getAttributeValue({ appData: selectedJsonData }, t, m.Name)}
                            </td>
                          </tr>
                        ))}
                    </thead>
                  </table>
                ))}
              </>
            }
          </> :
          <div className="ml-3">
            <EditPartner
              handleAddEditRecruiter={handleAddEditRecruiter}
              selectedTab="addEditRecruiter"
            />
          </div>
        }

      </div>

    </div>
  );
}

export default Recruiter;
